var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.798,
    height: 29.923,
    viewBox: "0 0 23.798 29.923",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-330.07 -28.968)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(330.07 29.308)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M859.4,244.153H837.528a.977.977,0,0,1-.958-1.055l1.385-21.65a.974.974,0,0,1,.96-.924h19.293a.973.973,0,0,1,.959.933l1.2,21.65A.976.976,0,0,1,859.4,244.153Z",
    transform: "translate(-836.568 -214.57)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.841 -0.34)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M843.045,220.7v-.015a6.021,6.021,0,1,1,12.031,0h-1.819a4.2,4.2,0,1,0-8.393,0Z",
    transform: "translate(-843.045 -214.405)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.ddaf239c8c5e807ffd7d87230842d40e.svg";
export { ForwardRef as ReactComponent };